import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';


const initReviewsBlocksSlider = () => {
    
    const reviewsBlocks = Array.from(document.querySelectorAll('.block-reviews__slider'));

    reviewsBlocks.forEach(el => {
        
        if (el.inited) {
            return;
        }
        el.inited = true;

        const swiper = new Swiper(el, {
            modules: [Navigation],
            navigation: {
                nextEl: '.block-reviews__slider-nav-next',
                prevEl: '.block-reviews__slider-nav-prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 50,
                },
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 82,
                },
            }
        });
    });
};

(() => {
    initReviewsBlocksSlider();
})();

export default initReviewsBlocksSlider;
